/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import cl from 'classnames';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';

export const languageOptions = [
    { value: 'aa', label: 'Afar' },
    { value: 'ab', label: 'Abkhaz' },
    { value: 'ae', label: 'Avestan' },
    { value: 'af', label: 'Afrikaans' },
    { value: 'ak', label: 'Akan' },
    { value: 'am', label: 'Amharic' },
    { value: 'an', label: 'Aragonese' },
    { value: 'ar', label: 'Arabic' },
    { value: 'as', label: 'Assamese' },
    { value: 'av', label: 'Avaric' },
    { value: 'ay', label: 'Aymara' },
    { value: 'az', label: 'Azerbaijani' },
    { value: 'ba', label: 'Bashkir' },
    { value: 'be', label: 'Belarusian' },
    { value: 'bg', label: 'Bulgarian' },
    { value: 'bh', label: 'Bihari' },
    { value: 'bi', label: 'Bislama' },
    { value: 'bm', label: 'Bambara' },
    { value: 'bn', label: 'Bengali' },
    { value: 'bo', label: 'Tibetan' },
    { value: 'br', label: 'Breton' },
    { value: 'bs', label: 'Bosnian' },
    { value: 'ca', label: 'Catalan' },
    { value: 'ce', label: 'Chechen' },
    { value: 'ch', label: 'Chamorro' },
    { value: 'co', label: 'Corsican' },
    { value: 'cr', label: 'Cree' },
    { value: 'cs', label: 'Czech' },
    { value: 'cu', label: 'Old Church Slavonic' },
    { value: 'cv', label: 'Chuvash' },
    { value: 'cy', label: 'Welsh' },
    { value: 'da', label: 'Danish' },
    { value: 'de', label: 'German' },
    { value: 'dv', label: 'Divehi' },
    { value: 'dz', label: 'Dzongkha' },
    { value: 'ee', label: 'Ewe' },
    { value: 'el', label: 'Greek' },
    { value: 'en', label: 'English' },
    { value: 'eo', label: 'Esperanto' },
    { value: 'es', label: 'Spanish' },
    { value: 'et', label: 'Estonian' },
    { value: 'eu', label: 'Basque' },
    { value: 'fa', label: 'Persian' },
    { value: 'ff', label: 'Fula' },
    { value: 'fi', label: 'Finnish' },
    { value: 'fj', label: 'Fijian' },
    { value: 'fo', label: 'Faroese' },
    { value: 'fr', label: 'French' },
    { value: 'fy', label: 'Western Frisian' },
    { value: 'ga', label: 'Irish' },
    { value: 'gd', label: 'Scottish Gaelic' },
    { value: 'gl', label: 'Galician' },
    { value: 'gu', label: 'Gujarati' },
    { value: 'gv', label: 'Manx' },
    { value: 'ha', label: 'Hausa' },
    { value: 'he', label: 'Hebrew' },
    { value: 'hi', label: 'Hindi' },
    { value: 'ho', label: 'Hiri Motu' },
    { value: 'hr', label: 'Croatian' },
    { value: 'ht', label: 'Haitian' },
    { value: 'hu', label: 'Hungarian' },
    { value: 'hy', label: 'Armenian' },
    { value: 'hz', label: 'Herero' },
    { value: 'ia', label: 'Interlingua' },
    { value: 'id', label: 'Indonesian' },
    { value: 'ie', label: 'Interlingue' },
    { value: 'ig', label: 'Igbo' },
    { value: 'ii', label: 'Nuosu' },
    { value: 'ik', label: 'Inupiaq' },
    { value: 'io', label: 'Ido' },
    { value: 'is', label: 'Icelandic' },
    { value: 'it', label: 'Italian' },
    { value: 'iu', label: 'Inuktitut' },
    { value: 'ja', label: 'Japanese' },
    { value: 'jv', label: 'Javanese' },
    { value: 'ka', label: 'Georgian' },
    { value: 'kg', label: 'Kongo' },
    { value: 'ki', label: 'Kikuyu' },
    { value: 'kj', label: 'Kwanyama' },
    { value: 'kk', label: 'Kazakh' },
    { value: 'kl', label: 'Kalaallisut' },
    { value: 'km', label: 'Khmer' },
    { value: 'kn', label: 'Kannada' },
    { value: 'ko', label: 'Korean' },
    { value: 'kr', label: 'Kanuri' },
    { value: 'ks', label: 'Kashmiri' },
    { value: 'ku', label: 'Kurdish' },
    { value: 'kv', label: 'Komi' },
    { value: 'kw', label: 'Cornish' },
    { value: 'ky', label: 'Kyrgyz' },
    { value: 'la', label: 'Latin' },
    { value: 'lb', label: 'Luxembourgish' },
    { value: 'lg', label: 'Ganda' },
    { value: 'li', label: 'Limburgish' },
    { value: 'ln', label: 'Lingala' },
    { value: 'lo', label: 'Lao' },
    { value: 'lt', label: 'Lithuanian' },
    { value: 'lu', label: 'Luba-Katanga' },
    { value: 'lv', label: 'Latvian' },
    { value: 'mg', label: 'Malagasy' },
    { value: 'mh', label: 'Marshallese' },
    { value: 'mi', label: 'Māori' },
    { value: 'mk', label: 'Macedonian' },
    { value: 'ml', label: 'Malayalam' },
    { value: 'mn', label: 'Mongolian' },
    { value: 'mr', label: 'Marathi' },
    { value: 'ms', label: 'Malay' },
    { value: 'mt', label: 'Maltese' },
    { value: 'my', label: 'Burmese' },
    { value: 'na', label: 'Nauru' },
    { value: 'nb', label: 'Norwegian Bokmål' },
    { value: 'nd', label: 'Northern Ndebele' },
    { value: 'ne', label: 'Nepali' },
    { value: 'ng', label: 'Ndonga' },
    { value: 'nl', label: 'Dutch' },
    { value: 'nn', label: 'Norwegian Nynorsk' },
    { value: 'no', label: 'Norwegian' },
    { value: 'nr', label: 'Southern Ndebele' },
    { value: 'nv', label: 'Navajo' },
    { value: 'ny', label: 'Chichewa' },
    { value: 'oc', label: 'Occitan' },
    { value: 'oj', label: 'Ojibwe' },
    { value: 'om', label: 'Oromo' },
    { value: 'or', label: 'Oriya' },
    { value: 'os', label: 'Ossetian' },
    { value: 'pa', label: 'Panjabi' },
    { value: 'pi', label: 'Pāli' },
    { value: 'pl', label: 'Polish' },
    { value: 'ps', label: 'Pashto' },
    { value: 'pt', label: 'Portuguese' },
    { value: 'qu', label: 'Quechua' },
    { value: 'rm', label: 'Romansh' },
    { value: 'rn', label: 'Kirundi' },
    { value: 'ro', label: 'Romanian' },
    { value: 'ru', label: 'Russian' },
    { value: 'rw', label: 'Kinyarwanda' },
    { value: 'sa', label: 'Sanskrit' },
    { value: 'sc', label: 'Sardinian' },
    { value: 'sd', label: 'Sindhi' },
    { value: 'se', label: 'Northern Sami' },
    { value: 'sg', label: 'Sango' },
    { value: 'si', label: 'Sinhala' },
    { value: 'sk', label: 'Slovak' },
    { value: 'sl', label: 'Slovenian' },
    { value: 'sn', label: 'Shona' },
    { value: 'so', label: 'Somali' },
    { value: 'sq', label: 'Albanian' },
    { value: 'sr', label: 'Serbian' },
    { value: 'ss', label: 'Swati' },
    { value: 'st', label: 'Southern Sotho' },
    { value: 'su', label: 'Sundanese' },
    { value: 'sv', label: 'Swedish' },
    { value: 'sw', label: 'Swahili' },
    { value: 'ta', label: 'Tamil' },
    { value: 'te', label: 'Telugu' },
    { value: 'tg', label: 'Tajik' },
    { value: 'th', label: 'Thai' },
    { value: 'ti', label: 'Tigrinya' },
    { value: 'tk', label: 'Turkmen' },
    { value: 'tl', label: 'Tagalog' },
    { value: 'tn', label: 'Tswana' },
    { value: 'to', label: 'Tonga' },
    { value: 'tr', label: 'Turkish' },
    { value: 'ts', label: 'Tsonga' },
    { value: 'tt', label: 'Tatar' },
    { value: 'tw', label: 'Twi' },
    { value: 'ty', label: 'Tahitian' },
    { value: 'ug', label: 'Uyghur' },
    { value: 'uk', label: 'Ukrainian' },
    { value: 'ur', label: 'Urdu' },
    { value: 'uz', label: 'Uzbek' },
    { value: 've', label: 'Venda' },
    { value: 'vi', label: 'Vietnamese' },
    { value: 'vo', label: 'Volapük' },
    { value: 'wa', label: 'Walloon' },
    { value: 'wo', label: 'Wolof' },
    { value: 'xh', label: 'Xhosa' },
    { value: 'yi', label: 'Yiddish' },
    { value: 'yo', label: 'Yoruba' },
    { value: 'za', label: 'Zhuang' },
    { value: 'zh', label: 'Chinese' },
    { value: 'zu', label: 'Zulu' },
];

// eslint-disable-next-line react/prop-types
const MultiValueLabel = (props) => {
    const { data } = props;
    return (
        <>
            <components.MultiValueLabel {...props}>
                <span>{data.value.toUpperCase()}</span>
            </components.MultiValueLabel>
        </>
    );
};
const MultiValueRemove = (props) => {
    const { selectProps } = props;
    const { value, minimumLength } = selectProps;
    return value.length <= minimumLength ? null : (
        <>
            <components.MultiValueRemove {...props} />
        </>
    );
};
const Option = (props) => {
    const { data } = props;
    return (
        <components.Option {...props}>
            <span className={cl('select__option__label')}>{data.label}</span>
        </components.Option>
    );
};

export default class LanguageSelect extends Component {
    constructor(props) {
        super(props);
        const { defaultValue } = props;
        const defaultLanguages =
            defaultValue &&
            defaultValue.map((defaultLanguage) => languageOptions.find((item) => item.value === defaultLanguage));
        this.state = {
            languages: defaultLanguages,
        };
    }

    getOptions = () => {
        const { filter } = this.props;
        if (filter && filter.length > 0) {
            return languageOptions
                .filter((item) => filter.includes(item.value))
                .sort((a, b) => filter.indexOf(a.value) - filter.indexOf(b.value));
        }
        return languageOptions;
    };

    onChange = (newLanguages, actionMeta) => {
        const { minimumLength, isMulti, onChange } = this.props;
        if (
            (actionMeta.action === 'remove-value' || actionMeta.action === 'pop-value') &&
            newLanguages.length < minimumLength &&
            isMulti
        ) {
            return;
        }
        if (onChange !== null) onChange(newLanguages);
        this.setState({ languages: newLanguages });
    };

    renderInput() {
        const { placeholder, onChange, size, isMulti, value, className, minimumLength, defaultValue, ...rest } =
            this.props;
        const { languages } = this.state;
        delete rest.className;
        return (
            <Select
                isMulti={isMulti}
                className="select__item select__item--language"
                classNamePrefix="select"
                options={this.getOptions()}
                components={{ MultiValueLabel, MultiValueRemove, Option }}
                placeholder={placeholder}
                onChange={this.onChange}
                isClearable={false}
                value={languages}
                minimumLength={minimumLength}
                {...rest}
            />
        );
    }

    render() {
        const { size, className, error, label, hideLabel, icon, ...rest } = this.props;
        const errorComponent = error ? <span className="select__error">{error}</span> : null;
        const classesContainer = cl('select', { 'select--iconed': icon }, `select--${size}`, className);
        return (
            <div className={classesContainer}>
                {hideLabel ? (
                    this.renderInput({ error, size, ...rest })
                ) : (
                    <>
                        {label && (
                            <label className="select__label" htmlFor={this.inputId}>
                                {label}
                            </label>
                        )}
                        {this.renderInput({ error, size, ...rest })}
                    </>
                )}
                {icon}
                {errorComponent}
            </div>
        );
    }
}

LanguageSelect.defaultProps = {
    filter: [],
    isMulti: false,
    placeholder: '',
    onChange: null,
    size: 'normal',
    className: null,
    hideLabel: false,
    icon: null,
    value: null,
    defaultValue: null,
    label: null,
    error: null,
    minimumLength: 0,
};
LanguageSelect.propTypes = {
    filter: PropTypes.array,
    isMulti: PropTypes.bool,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    defaultValue: PropTypes.arrayOf(PropTypes.oneOf(languageOptions.map((x) => x.value))),
    minimumLength: PropTypes.number,
    onChange: PropTypes.func,
    className: PropTypes.string,
    size: PropTypes.oneOf(['big', 'normal', 'small', 'mini']),
    label: PropTypes.string,
    error: PropTypes.string,
    hideLabel: PropTypes.bool,
    icon: PropTypes.string,
};
